import i18next from 'i18next';
import { DeviceWithoutGatewayFormDataModel, CombinedDeviceWithoutGatewayFormValueNames } from '../models';

export const DEVICE_WITHOUT_GATEWAY_CREATE_FORM_GENERAL_GROUP_VALUE = 2;

const defaultGeneralFormValue: DeviceWithoutGatewayFormDataModel = {
  key: '',
  formGroupValue: DEVICE_WITHOUT_GATEWAY_CREATE_FORM_GENERAL_GROUP_VALUE,
  label: '',
  placeholder: '',
  required: false,
  multiple: false,
  value: '',
  units: '',
  rules: [],
};

export const getInitialGeneralFormValues = (): DeviceWithoutGatewayFormDataModel[] => {
  return [
    {
      ...defaultGeneralFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.NAME,
      label: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_NAME_LABEL'),
      placeholder: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_NAME_PLACEHOLDER'),
      required: true,
      rules: [{ required: true, message: i18next.t('required_field') }],
    },
    {
      ...defaultGeneralFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.ROOM,
      label: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_ROOM_LABEL'),
      placeholder: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_ROOM_PLACEHOLDER'),
      required: true,
      rules: [{ required: true, message: i18next.t('required_field') }],
    },
    {
      ...defaultGeneralFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.COMMUNICATION_PLATFORM_IP,
      label: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_IP_LABEL'),
      placeholder: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_IP_PLACEHOLDER'),
      rules: [{ required: true, message: i18next.t('required_field') }],
    },
    {
      ...defaultGeneralFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.COMMUNICATION_PLATFORM_PORT,
      label: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_PORT_LABEL'),
      placeholder: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_PORT_PLACEHOLDER'),
    },
    {
      ...defaultGeneralFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.REPORTING_INTERVAL_NUMBER,
      label: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_INTERVAL_NUMBER_LABEL'),
      placeholder: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_INTERVAL_NUMBER_PLACEHOLDER'),
    },
    {
      ...defaultGeneralFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.REPORTING_INTERVAL_TIME,
      label: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_INTERVAL_TIME_LABEL'),
      placeholder: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_INTERVAL_TIME_PLACEHOLDER'),
    },
    {
      ...defaultGeneralFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.SECRET_KEY,
      label: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SECRET_KEY_LABEL'),
      placeholder: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SECRET_KEY_PLACEHOLDER'),
    },
    {
      ...defaultGeneralFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.BUILDING_ID,
      label: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_BUILDING_ID_LABEL'),
      placeholder: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_BUILDING_ID_PLACEHOLDER'),
    },
    {
      ...defaultGeneralFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.SERIAL_NUMBER,
      label: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SERIAL_NUMBER_LABEL'),
      placeholder: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SERIAL_NUMBER_PLACEHOLDER'),
      required: true,
      rules: [{ required: true, message: i18next.t('required_field') }],
    },
    {
      ...defaultGeneralFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.MAIN_CONVERSION_FACTOR,
      label: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_MAIN_CONVERSION_FACTOR_LABEL'),
      placeholder: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_MAIN_CONVERSION_FACTOR_PLACEHOLDER'),
    },
  ];
};
